import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../config";
import Loader from "./Loader";
import { Link } from "react-router-dom";
import {
  HIDDEN_KEYS,
  filterVisible,
  hideItem,
} from "../utils/hiddenHistory";

export default function Stock() {
  const [stocks, setStocks] = useState([]);
  const [stock, setStock] = useState({
    id: "",
    name: "",
    sku: "",
    quantity: 0,
    price: 0,
  });
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [listVersion, setListVersion] = useState(0);

  useEffect(() => {
    fetchStocks();
  }, []);

  const fetchStocks = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/stocks`);
      setStocks(response.data);
    } catch (error) {
      console.error("Error fetching stock data", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setStock({
      ...stock,
      [name]: name === "quantity" || name === "price" ? Number(value) : value,
    });
  };

  const closeModal = () => {
    setStock({ id: "", name: "", sku: "", quantity: 0, price: 0 });
    setShowModal(false);
  };

  const saveStock = async (e) => {
    e.preventDefault();
    try {
      if (stock.id) {
        await axios.put(`${API_BASE_URL}/api/stocks/${stock.id}`, stock);
        alert("Stock item updated");
      } else {
        await axios.post(`${API_BASE_URL}/api/stocks`, stock);
        alert("Stock item added");
      }
      fetchStocks();
      closeModal();
    } catch (error) {
      console.error("Error saving stock item", error);
      alert("Failed to save stock item");
    }
  };

  const editStock = (item) => {
    setStock({
      id: item.id,
      name: item.name,
      sku: item.sku || "",
      quantity: item.quantity,
      price: item.price,
    });
    setShowModal(true);
  };

  const deleteStock = (id) => {
    if (!window.confirm("Remove this item from the list? Restore it from History."))
      return;
    hideItem(HIDDEN_KEYS.stock, id);
    setListVersion((v) => v + 1);
  };

  const openAddModal = () => {
    setStock({ id: "", name: "", sku: "", quantity: 0, price: 0 });
    setShowModal(true);
  };

  const visibleStocks = filterVisible(stocks, HIDDEN_KEYS.stock);
  void listVersion;

  if (loading) {
    return <Loader message="Loading stockâ€¦" fullPage />;
  }

  return (
    <>
      <div className="container-fluid app-container">
        <div className="row">
          <div className="col-12">
            <div className="card app-screen-card">
              <div className="app-screen-card__head d-none d-md-flex justify-content-between align-items-center mb-3">
                <h4 className="app-card-title mb-0">Stock Items</h4>
                <div>
                  <button
                    type="button"
                    className="btn btn-primary app-btn me-2"
                    onClick={openAddModal}
                  >
                    Add Stock Item
                  </button>
                  <Link to="/history" className="btn btn-outline-secondary app-btn">
                    History
                  </Link>
                </div>
              </div>
              <div className="table-responsive app-table-wrap">
                <table className="table table-sm app-data-table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>SKU</th>
                      <th>Qty</th>
                      <th>Price</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {visibleStocks.map((item) => (
                      <tr key={item.id}>
                        <td data-label="Name">{item.name}</td>
                        <td data-label="SKU">{item.sku || "-"}</td>
                        <td data-label="Qty">{item.quantity}</td>
                        <td data-label="Price">
                          {Number(item.price).toFixed(2)}
                        </td>
                        <td data-label="Actions" className="cell-actions">
                          <button
                            className="btn btn-sm btn-outline-primary me-2"
                            onClick={() => editStock(item)}
                          >
                            Edit
                          </button>
                          <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => deleteStock(item.id)}
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <div
          className="app-modal-overlay"
          role="presentation"
          onClick={(e) => {
            if (e.target === e.currentTarget) closeModal();
          }}
        >
          <div
            className="app-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="stock-modal-title"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="app-modal__header">
              <h4 className="app-modal__title" id="stock-modal-title">
                {stock.id ? "Edit Stock Item" : "Add Stock Item"}
              </h4>
              <button
                type="button"
                className="app-modal__close"
                aria-label="Close"
                onClick={closeModal}
              >
              X
              </button>
            </div>
            <form onSubmit={saveStock}>
              <div className="app-modal__body">
                <div className="mb-3">
                  <label className="form-label">Name</label>
                  <input
                    className="form-control"
                    name="name"
                    value={stock.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">SKU</label>
                  <input
                    className="form-control"
                    name="sku"
                    value={stock.sku}
                    onChange={handleChange}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Quantity</label>
                  <input
                    className="form-control"
                    name="quantity"
                    type="number"
                    value={stock.quantity}
                    onChange={handleChange}
                    min="0"
                    required
                  />
                </div>
                <div className="mb-0">
                  <label className="form-label">Price</label>
                  <input
                    className="form-control"
                    name="price"
                    type="number"
                    step="0.01"
                    value={stock.price}
                    onChange={handleChange}
                    min="0"
                    required
                  />
                </div>
              </div>
              <div className="app-modal__footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closeModal}
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary">
                  {stock.id ? "Update" : "Add"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
